import { default as WscIconGettyGLogo } from "./GettyGLogo";
import { default as WscIconGettyImagesLogo } from "./GettyImagesLogo";

const icons = {
  WscIconGettyGLogo,
  WscIconGettyImagesLogo,
};

export default icons;
